/**
 * 计算上传剩余时间
 * @param res
 * @returns {string}
 */

export function getTime (res) {
  // 计算出小时数
  let leave1 = res % (24 * 3600 * 1000)
  let hours = Math.floor(leave1 / (3600 * 1000))
  // 计算相差分钟数
  let leave2 = leave1 % (3600 * 1000)
  let minutes = Math.floor(leave2 / (60 * 1000))
  // 计算相差秒数
  let leave3 = leave2 % (60 * 1000)
  let seconds = Math.round(leave3 / 1000)
  return checkTime(hours) + ':' + checkTime(minutes) + ':' + checkTime(seconds)
}

/**
 * 转换时间补0
 * @param i
 * @returns {*}
 */

export function checkTime (i) {
  if (i < 10) {
    if (i < 0) {
      i = '00'
    } else {
      i = '0' + i
    }
  }
  return i
}



// WEBPACK FOOTER //
// ./src/components/upload/utils.js